fragment WfFormChatFragment on Form {
    id
    name
    publicFormId
    lastSubmittedTime
    htmlUrlPath
}
